/**
 * Sticky Add-to-Cart Bar for Mobile
 * Always visible at bottom of mobile product pages for maximum conversion
 * Simple, predictable UX with no scroll-based visibility logic
 */

(function() {
  'use strict';

  // Only run on product pages and mobile devices
  var isProductPage = window.location.pathname.includes('/products/');
  var isMobile = window.innerWidth <= 749;

  if (!isProductPage || !isMobile) {
    console.log('[Sticky Bar] Not running - not product page or not mobile');
    return;
  }

  function init() {
    var stickyBar = document.querySelector('.product-form__sticky-bar');
    if (!stickyBar) {
      console.log('[Sticky Bar] Bar element not found');
      return;
    }

    // Show the bar immediately
    stickyBar.classList.add('product-form__sticky-bar--visible');
    console.log('[Sticky Bar] Always-visible bar initialized');

    // Sync sticky button with original form
    var stickyButton = stickyBar.querySelector('.product-form__sticky-bar-button');
    var productForm = document.querySelector('product-form form');

    if (stickyButton && productForm) {
      stickyButton.addEventListener('click', function(e) {
        e.preventDefault();

        // Trigger the original form submission
        var submitButton = productForm.querySelector('[name="add"]');
        if (submitButton) {
          submitButton.click();
        }
      });
    }

    // Update sticky bar price and variant when variant changes
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        var data = event.data || event;
        var variant = data.variant;

        if (!variant) return;

        // Update price amount
        var priceAmountElement = stickyBar.querySelector('.product-form__sticky-bar-price-amount');

        if (variant.price && priceAmountElement) {
          var formattedPrice;

          // Try to use Shopify.formatMoney if available
          if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
            var moneyFormat = Shopify.money_format || '£{{amount}}';
            formattedPrice = Shopify.formatMoney(variant.price, moneyFormat);
          } else {
            // Fallback: format manually (assumes GBP)
            formattedPrice = '£' + (variant.price / 100).toFixed(2);
          }

          priceAmountElement.textContent = formattedPrice;
        }

        // Update bundle size (shown on same line as price)
        var bundleElement = stickyBar.querySelector('.product-form__sticky-bar-bundle');
        if (bundleElement) {
          if (variant.title && variant.title !== 'Default Title') {
            // Split by ' - ' to separate bundle size from details
            var parts = variant.title.split(' - ');
            bundleElement.textContent = parts[0];
          } else {
            bundleElement.textContent = '';
          }
        }

        // Update variant details (shown below price on new line)
        var detailsElement = stickyBar.querySelector('.product-form__sticky-bar-details');
        if (detailsElement) {
          if (variant.title && variant.title !== 'Default Title') {
            var parts = variant.title.split(' - ');
            detailsElement.textContent = parts.length > 1 ? parts[1] : '';
          } else {
            detailsElement.textContent = '';
          }
        }

        // Update button availability
        var button = stickyBar.querySelector('.product-form__sticky-bar-button');
        if (button) {
          if (variant.available) {
            button.disabled = false;
            button.textContent = button.getAttribute('data-default-text') || 'Add to cart';
          } else {
            button.disabled = true;
            button.textContent = 'Sold out';
          }
        }
      });
    }

    // Temporarily hide bar after add-to-cart, then re-show
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
        if (event.cartData && event.cartData.item_count > 0) {
          stickyBar.classList.remove('product-form__sticky-bar--visible');

          // Re-show after 3 seconds in case user wants to add more
          setTimeout(function() {
            stickyBar.classList.add('product-form__sticky-bar--visible');
          }, 3000);
        }
      });
    }
  }

  // Run on DOMContentLoaded or immediately if DOM is already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
